<mat-card class="course-card">
  <img
    mat-card-image
    class="course-card-image"
    [src]="_imageLink"
    alt="Course image"
  />
  <mat-card-content>
    <div class="title">{{ _title }}</div>
    <div class="status">
      <span *ngIf="!_completed && !_todo">{{ _percentage }}% complete</span>
      <span *ngIf="_completed">Completed!</span>
      <span *ngIf="_todo">To Do</span>
    </div>
    <div class="button-container">
      <app-action-button
        size="wider"
        kind="filled"
        [color]="getButtonColor(_completed)"
        (onClick)="redirectToUrl(_url)"
        >{{ getButtonText(_completed) }}</app-action-button
      >
    </div>
  </mat-card-content>
</mat-card>
